import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const ACCIDENTS_EMPTY_VALUE = '---';
export const ACCIDENTS_DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';

export const FALSE_ALARM_NEXT_STEP = 'Ignore (False Alarm)';

// Static backdrop so an outside click can't discard a half-filled form
export const FORM_MODAL_OPTIONS: Readonly<NgbModalOptions> = {
  centered: true,
  backdrop: 'static'
};

export const ATTACHMENTS_VIEWER_MODAL_OPTIONS: Readonly<NgbModalOptions> = {
  centered: true,
  windowClass: 'photos-videos-viewer-modal'
};

export const INCIDENT_DETAILS_MODAL_OPTIONS: Readonly<NgbModalOptions> = {
  centered: true,
  windowClass: 'incident-details-modal-window'
};
